function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { getAllowedReadDataset, getMasterStageDataset, MAX_ATHENA_TABLE_NAME, R_LINK_SUFFIX } from '@/apps/attributes/config/sql_constants';
function generateShortUuid() {
  var arr = new Uint8Array(4);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(arr);
  } else {
    for (var i = 0; i < 4; i++) arr[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(arr).map(function (b) {
    return b.toString(16).padStart(2, '0');
  }).join('');
}
function stripLineComments(sql) {
  return sql.replace(/--[^\n]*/g, '');
}
function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
export function extractCreateTables(sql) {
  var clean = stripLineComments(sql);
  var regex = /CREATE\s+TABLE\s+(?:IF\s+NOT\s+EXISTS\s+)?(?:"?([a-zA-Z0-9_]+)"?\s*\.\s*)?"?([a-zA-Z0-9_]+)"?/gi;
  var results = [];
  var match;
  while ((match = regex.exec(clean)) !== null) {
    results.push({
      originalDataset: match[1] || null,
      originalTable: match[2]
    });
  }
  return results;
}
export function extractReferencedTables(sql) {
  var clean = stripLineComments(sql);
  // Remove CREATE TABLE destination tokens so they don't appear as references
  var withoutTargets = clean.replace(/CREATE\s+TABLE\s+(?:IF\s+NOT\s+EXISTS\s+)?(?:"?[a-zA-Z0-9_]+"?\s*\.\s*)?"?[a-zA-Z0-9_]+"?/gi, '');
  var regex = /\b(?:FROM|JOIN|DELETE\s+FROM)\s+"?([a-zA-Z0-9_]+)"?\s*\.\s*"?([a-zA-Z0-9_]+)"?/gi;
  var seen = new Set();
  var results = [];
  var match;
  while ((match = regex.exec(withoutTargets)) !== null) {
    var key = "".concat(match[1].toLowerCase(), ".").concat(match[2].toLowerCase());
    if (!seen.has(key)) {
      seen.add(key);
      results.push({
        dataset: match[1],
        table: match[2]
      });
    }
  }
  return results;
}
function normalizeRlinkDataset(dataset) {
  var dsLower = dataset.toLowerCase();
  return dsLower.endsWith(R_LINK_SUFFIX) ? dsLower.slice(0, -R_LINK_SUFFIX.length) : dsLower;
}
function findLocalCreateRewrite(createTableRewrites, ref, allowedLower) {
  var dsLower = ref.dataset.toLowerCase();
  var tableLower = ref.table.toLowerCase();
  var exactKey = "".concat(dsLower, ".").concat(tableLower);
  var exactRewrite = createTableRewrites.get(exactKey);
  if (exactRewrite) return exactRewrite;
  var dsNormalized = normalizeRlinkDataset(ref.dataset);
  var normalizedRewrite = createTableRewrites.get("".concat(dsNormalized, ".").concat(tableLower));
  if (normalizedRewrite) return normalizedRewrite;
  if (dsNormalized === allowedLower) {
    return createTableRewrites.get(".".concat(tableLower));
  }
  return null;
}

// eslint-disable-next-line no-unused-vars
export function buildRewrites(createTables, referencedTables, dbReadNames) {
  var errors = [];
  var createTableRewrites = new Map();
  var referencedRewrites = new Map();
  var _iterator = _createForOfIteratorHelper(createTables),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ct = _step.value;
      var uuid = generateShortUuid();
      var newTable = "".concat(ct.originalTable, "_").concat(uuid);
      if (newTable.length > MAX_ATHENA_TABLE_NAME) {
        errors.push("Tabla \"".concat(ct.originalTable, "\" excede el l\xEDmite Athena (").concat(MAX_ATHENA_TABLE_NAME, " chars) al agregar UUID (resultado: ").concat(newTable.length, " chars)"));
        continue;
      }
      var dsKey = (ct.originalDataset || '').toLowerCase();
      var key = "".concat(dsKey, ".").concat(ct.originalTable.toLowerCase());
      createTableRewrites.set(key, {
        hadDataset: ct.originalDataset !== null,
        originalDataset: ct.originalDataset,
        originalTable: ct.originalTable,
        newDataset: getMasterStageDataset(),
        newTable: newTable
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var allowed = getAllowedReadDataset();
  var allowedLower = allowed.toLowerCase();
  var allowedWithSuffix = allowed + R_LINK_SUFFIX;
  var _iterator2 = _createForOfIteratorHelper(referencedTables),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var ref = _step2.value;
      var dsLower = ref.dataset.toLowerCase();
      var _key = "".concat(dsLower, ".").concat(ref.table.toLowerCase());
      var localCreateRewrite = findLocalCreateRewrite(createTableRewrites, ref, allowedLower);
      if (localCreateRewrite) {
        referencedRewrites.set(_key, {
          newDataset: localCreateRewrite.newDataset,
          newTable: localCreateRewrite.newTable,
          skipPartitionValidation: true
        });
        continue;
      }
      var dsNormalized = normalizeRlinkDataset(ref.dataset);
      if (dsNormalized !== allowedLower) {
        errors.push("Tabla \"".concat(ref.dataset, ".").concat(ref.table, "\" usa la base de datos \"").concat(ref.dataset, "\" que no est\xE1 permitida. Solo se permite \"").concat(allowed, "\"."));
        continue;
      }

      // Referenced tables already exist in the lake — keep the original table name,
      // only rewrite the dataset to the *_rlink variant.
      referencedRewrites.set(_key, {
        newDataset: allowedWithSuffix,
        newTable: ref.table,
        skipPartitionValidation: false
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    createTableRewrites: createTableRewrites,
    referencedRewrites: referencedRewrites,
    errors: errors
  };
}
export function buildReferencedTablesPayload(referencedRewrites) {
  var seen = new Set();
  var payload = [];
  var _iterator3 = _createForOfIteratorHelper(referencedRewrites),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        val = _step3$value[1];
      if (val.skipPartitionValidation) continue;
      var key = "".concat(val.newDataset.toLowerCase(), ".").concat(val.newTable.toLowerCase());
      if (seen.has(key)) continue;
      seen.add(key);
      payload.push({
        dataset: val.newDataset,
        table: val.newTable
      });
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return payload;
}
export function applyRewrites(sql, createTableRewrites, referencedRewrites) {
  var result = sql;
  var _iterator4 = _createForOfIteratorHelper(createTableRewrites),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _slicedToArray(_step4.value, 2),
        val = _step4$value[1];
      var re = void 0;
      if (val.hadDataset) {
        re = new RegExp("(CREATE\\s+TABLE\\s+(?:IF\\s+NOT\\s+EXISTS\\s+)?)\"?".concat(escapeRegex(val.originalDataset), "\"?\\s*\\.\\s*\"?").concat(escapeRegex(val.originalTable), "\"?"), 'gi');
      } else {
        re = new RegExp("(CREATE\\s+TABLE\\s+(?:IF\\s+NOT\\s+EXISTS\\s+)?)\"?".concat(escapeRegex(val.originalTable), "\"?(?!\\s*\\.)"), 'gi');
      }
      result = result.replace(re, "$1".concat(val.newDataset, ".").concat(val.newTable));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var _iterator5 = _createForOfIteratorHelper(referencedRewrites),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _step5$value = _slicedToArray(_step5.value, 2),
        key = _step5$value[0],
        _val = _step5$value[1];
      var _key$split = key.split('.'),
        _key$split2 = _slicedToArray(_key$split, 2),
        origDs = _key$split2[0],
        origTbl = _key$split2[1];
      var _re = new RegExp("(\\b(?:FROM|JOIN|DELETE\\s+FROM)\\s+)\"?".concat(escapeRegex(origDs), "\"?\\s*\\.\\s*\"?").concat(escapeRegex(origTbl), "\"?"), 'gi');
      result = result.replace(_re, "$1".concat(_val.newDataset, ".").concat(_val.newTable));
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return result;
}